services.factory('mockAPI', [
    '$socket', '$q', '$timeout', '$http',
    'md5', 'config', 'constants', 'ErrorService',
    function API($socket, $q, $timeout, $http,
                 md5, config, Const, ErrorService) {
        var self = this,
            requests = {},
            eventNameRegExp = /\b(connect|disconnect|sendServerTime|loginToken|error|refreshClient|refreshSite)/;

        self.status = false;

        function mockSocket(emit, data) {
            switch (emit) {

            case 'login':
                return {Code: 1, Description: '', Token: 'aaabbbcccddd'};

            case 'getCustomerData':
                return {
                    "Code": 1,
                    "data": {
                        "Email": "yurii.rynkov@pandats.com",
                        "FirstName": "Yurii",
                        "LastName": "Rynkov",
                        "CreatedOnDate": "01-02-2017",
                        "City": "Haifa",
                        "Country": "Israel",
                        "PostalCode": "123",
                        "PreferredLocale": "en",
                        "Street": "Some street",
                        "Telephone": "123123123",
                        "UserID": "12345",
                        "RealAccounts": [
                            {
                                Balance: '12345.67',
                                Credit: '0',
                                Currency: 'USD',
                                Enable: 'true',
                                Equity: '0',
                                Leverage: '0',
                                Margin: '0',
                                Login: '789456'
                            }
                        ],
                        "DemoAccounts": []
                    }
                };

            case 'mt4login':
                return {Code: 1, Description: ''};
            case 'forgotPassword':
                return {Code: 1, Description: ''};
            }
        }

        function createEmitMethod(event, cb) {
            return function socketGet(data) {
                //insert reqID to every request
                var reqId = setReqId(event, data),
                    _data = angular.extend({}, data || {}, {reqID: reqId}),
                    deferred = $q.defer(),
                    requestTimeout;

                function cancelRequest() {
                    //$socket.off(event);
                    console.log('canceling request!', angular.copy(_data));
                    delete requests[reqId];
                    deferred.reject('cancelRequest');
                    throw new ErrorService({
                        source: 'mockAPI',
                        type: Const.error.type.VALIDATION,
                        severity: 'warning',
                        code: 'cancelRequest',
                        data: {request: _data}
                    });
                }

                function requestResponse(response) {
                    //$socket.off(event);
                    delete requests[reqId];

                    if (typeof response === 'string') {
                        response = angular.fromJson(response);
                    }

                    //cancel timeout on successful resolve
                    requestTimeout && $timeout.cancel(requestTimeout);
                    requestTimeout = null;

                    deferred.resolve(response);
                }

                //check if request is exists
                if (requests[reqId]) return $q.reject();

                //$socket.emit(event, _data || {});

                //$socket.on(event, requestResponse);
                $timeout(function () {
                    return requestResponse(mockSocket(event, _data || {}));
                }, 500);

                //save current request
                requests[reqId] = deferred.promise;

                //cancel request on timeout
                requestTimeout = $timeout(cancelRequest, config.requestTimeout);

                return deferred.promise;
            }
        }

        function setReqId(event, data) {
            return md5.createHash(event + JSON.stringify(data));
        }

        function handleConnect() {
            var deferred = $q.defer();
            console.log('socket is connecting...');
            $socket.connect();

            $socket.on('connect', function () {
                console.log('socket connected!');
                self.status = true;
                return deferred.resolve();
            });

            return deferred.promise;
        }

        function removeAllSubscribers() {
            Object.keys($socket.subscribers()).forEach(function (eventName) {
                if (!eventNameRegExp.test(eventName)) {
                    $socket.removeAllListeners(eventName);
                }
            });
            self.status = false;
        }

        function handleDisconnect() {
            console.log('socket is disconnecting...');
            $socket.disconnect();
        }

        function getToken(login, password) {
            var httpConfig = {
                method: 'GET',
                url: config.loginUrl,
                params: {
                    Login: login,
                    Password: password,
                    Source: Const.system.loginSources[0].id
                },
                timeout: 5000
            };
            return $http(httpConfig)
                .then(function (response) {
                    if (response.data.Code != "1") {
                        throw new ErrorService({
                            source: 'API',
                            type: Const.error.type.VALIDATION,
                            code: 'authFailed',
                            data: {request: httpConfig.params, response: response.data}
                        });
                    }
                    return response.data;
                })
                .catch(function (err) {
                    //query failed of unknown reasons
                    if (err && typeof err === 'object' && err.status == '-1') {
                        throw new ErrorService({
                            source: 'API',
                            type: Const.error.type.NETWORK,
                            code: 'authTimeout',
                            data: {request: httpConfig.params}
                        })
                    }
                    //rethrow custom error
                    return $q.reject(err);
                })
        }

        $socket.on('disconnect', function () {
            console.log('socket disconnected!!!');
            requests = {};
            removeAllSubscribers();
        });

        return {
            status: function () {
                return self.status
            },
            connect: handleConnect,
            disconnect: handleDisconnect,
            login: createEmitMethod('login'),
            loginToken: createEmitMethod('loginToken'),
            quotesHistoryByTimeFrame: createEmitMethod('QuotesHistoryByTimeFrame'),
            mt4LoginToken: createEmitMethod('MT4LoginToken'),
            mt4Login: createEmitMethod('MT4Login'),
            mt4GetClientSymbols: createEmitMethod('MT4GetClientSymbols'),
            mt4GetAllSymbols: createEmitMethod('MT4GetAllSymbols'),
            mt4GetSymbolsSnapshot: createEmitMethod('MT4GetSymbolsSnapshot'),
            mt4GetOpenPositions: createEmitMethod('MT4GetOpenPositions'),
            mt4GetClosedPositions: createEmitMethod('MT4GetClosedPositions'),
            mt4GetChart: createEmitMethod('MT4GetChart'),
            mt4OpenPosition: createEmitMethod('MT4OpenPosition'),
            mt4ClosePosition: createEmitMethod('MT4ClosePosition'),
            mt4UpdatePosition: createEmitMethod('MT4UpdatePosition'),
            mt4DeletePosition: createEmitMethod('MT4DeletePosition'),
            getCustomerData: createEmitMethod('getCustomerData'),
            logout: createEmitMethod('logout'),
            quotesSubscribe: createEmitMethod('quotesSubscribe'),
            quotesUnsubscribe: createEmitMethod('quotesUnsubscribe'),
            forgotPassword: createEmitMethod('forgotPassword'),
            subscribe: function (event, handler) {
                $socket.on(event, handler);
            },
            unsubscribe: function (event) {
                $socket.off(event);
            },
            onConnect: function (cb) {
                $socket.on('connect', cb);
            },
            onDisconnect: function (cb) {
                $socket.on('disconnect', cb);
            },
            onReconnect: function (cb) {
                $socket.on('reconnect', cb);
            },
            getToken: getToken
        }
    }
]);